/* eslint-disable @typescript-eslint/no-empty-function */
import React, {
  useState,
  useContext,
  Dispatch,
  SetStateAction,
  useEffect,
  createContext,
} from 'react'

import { BulkHistoryDataFilters, Filters } from '@types'

type ContextState = {
  setFilters: Dispatch<SetStateAction<Filters>>
  bulkDataFilters: BulkHistoryDataFilters
  setBulkDataFilters: Dispatch<SetStateAction<BulkHistoryDataFilters>>
  resetFilters: () => void
  filters?: Filters
  resetTriggered: number
}

const initialState = {
  filters: { statusName: [], page: 1 },
  setFilters: () => {},
  bulkDataFilters: {
    limit: 5,
    page: 1,
    orderBy: 'ASC',
  },
  setBulkDataFilters: () => {},
  resetFilters: () => {},
  resetTriggered: 0,
}

const FiltersContext = createContext<ContextState>(initialState)

type FiltersProviderProps = {
  children: React.ReactNode
  customized?: Filters
}

export function FiltersProvider(props: FiltersProviderProps) {
  const { children, customized } = props
  const [filters, setFilters] = useState<Filters>({
    ...initialState.filters,
    ...customized,
  })
  const [bulkDataFilters, setBulkDataFilters] = useState<BulkHistoryDataFilters>(
    initialState.bulkDataFilters,
  )
  const [resetTriggered, setResetTriggered] = useState<number>(0)

  const resetFilters = () => {
    setResetTriggered(state => state + 1)
  }

  useEffect(() => {
    if (resetTriggered) {
      setFilters({
        ...initialState.filters,
        ...customized,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetTriggered])

  return (
    <FiltersContext.Provider
      value={{
        filters,
        setFilters,
        bulkDataFilters,
        setBulkDataFilters,
        resetFilters,
        resetTriggered,
      }}
    >
      {children}
    </FiltersContext.Provider>
  )
}

export function useFilters(): ContextState {
  const context = useContext(FiltersContext)

  if (!context) throw Error('This hook can only be used under the FiltersProvider component')
  return context
}
